// extracted by mini-css-extract-plugin
export default {"icono":"Iconos_icono__qUKgq","iconoMovimiento":"Iconos_iconoMovimiento__bZR5j","iconoTitulo":"Iconos_iconoTitulo__eeBWS"};